import colors from "./colors";

const chakraPink = {
  50: "#FFF5F7",
  100: "#FED7E2",
  700: "#97266D",
  900: "#521B41",
};

const semanticTokens = {
  colors: {
    pageBackground: {
      default: colors.pageBackground,
      _dark: colors.pageBackground,
    },
    surfaceBase: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceRaised: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceHighest: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceCard: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceMobile: {
      default: colors.white,
      _dark: colors.gray[900],
    },
    surfaceMuted: {
      default: colors.gray[50],
      _dark: colors.gray[50],
    },
    surfaceInteractive: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceInteractiveHover: {
      default: colors.gray[100],
      _dark: colors.gray[100],
    },
    surfaceInteractiveActive: {
      default: colors.gray[200],
      _dark: colors.gray[200],
    },
    surfaceInteractiveDisabled: {
      default: "#F2F2F2",
      _dark: colors.whiteAlpha[200],
    },
    surfaceMenu: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceMenuHover: {
      default: colors.gray[100],
      _dark: colors.gray[100],
    },
    surfaceMenuActive: {
      default: colors.gray[200],
      _dark: colors.gray[200],
    },
    surfaceComposer: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceQuestion: {
      default: colors.gray[50],
      _dark: colors.gray[50],
    },
    surfaceQuestionActive: {
      default: colors.blue[50],
      _dark: colors.blue[50],
    },
    surfaceNote: {
      default: colors.white,
      _dark: colors.white,
    },
    surfaceNoteHover: {
      default: colors.blue[50],
      _dark: "rgb(37, 47, 68)",
    },
    surfaceNoteBlock: {
      default: colors.white,
      _dark: colors.gray[50],
    },
    surfaceBannerBlue: {
      default: colors.blue[100],
      _dark: colors.blue[100],
    },
    surfaceBannerGreen: {
      default: colors.green[100],
      _dark: colors.green[100],
    },
    borderSubtle: {
      default: colors.gray[200],
      _dark: colors.gray[200],
    },
    borderMuted: {
      default: colors.gray[100],
      _dark: colors.gray[100],
    },
    borderFocus: {
      default: colors.blue[400],
      _dark: colors.blue[400],
    },
    borderReply: {
      default: colors.gray[200],
      _dark: colors.gray[200],
    },
    textHeading: {
      default: colors.gray[800],
      _dark: colors.gray[800],
    },
    textBody: {
      default: colors.gray[600],
      _dark: colors.gray[600],
    },
    textPrimary: {
      default: colors.gray[900],
      _dark: colors.gray[900],
    },
    textSubtle: {
      default: colors.gray[600],
      _dark: colors.gray[600],
    },
    textNote: {
      default: "#515863",
      _dark: "#515863",
    },
    textQuestion: {
      default: colors.gray[800],
      _dark: colors.gray[800],
    },
    textLink: {
      default: colors.gray[600],
      _dark: colors.gray[600],
    },
    textMeta: {
      default: colors.gray[500],
      _dark: colors.gray[500],
    },
    textInverse: {
      default: colors.white,
      _dark: colors.white,
    },
    textPlaceholderDefault: {
      default: "#808B97",
      _dark: "#808B97",
    },
    textPlaceholderHover: {
      default: "#808B97",
      _dark: "#808B97",
    },
    textPlaceholderFocus: {
      default: "#808B97",
      _dark: "#808B97",
    },
    iconSubtle: {
      default: colors.gray[600],
      _dark: colors.gray[600],
    },
    iconMuted: {
      default: colors.gray[400],
      _dark: colors.gray[400],
    },
    iconLink: {
      default: colors.gray[600],
      _dark: colors.gray[600],
    },
    highlightNote: {
      default: "rgba(79, 175, 253, 0.5)",
      _dark: "rgba(79, 175, 253, 0.5)",
    },
    buttonDisabledBg: {
      default: colors.gray[100],
      _dark: colors.gray[100],
    },
    buttonDisabledColor: {
      default: colors.gray[400],
      _dark: colors.gray[400],
    },
    buttonCopyBg: {
      default: colors.green[600],
      _dark: colors.green[600],
    },
    buttonCopyHoverBg: {
      default: colors.green[700],
      _dark: colors.green[700],
    },
    buttonCopyActiveBg: {
      default: colors.green[800],
      _dark: colors.green[800],
    },
    buttonCopyColor: {
      default: colors.white,
      _dark: colors.white,
    },
    buttonCopyActiveColor: {
      default: colors.white,
      _dark: colors.white,
    },
    buttonCopyIconColor: {
      default: colors.green[600],
      _dark: colors.green[600],
    },
    buttonCopyIconHoverBg: {
      default: colors.green[200],
      _dark: colors.green[200],
    },
    buttonCopyIconActiveBg: {
      default: colors.green[600],
      _dark: colors.green[600],
    },
    buttonCopyIconActiveColor: {
      default: colors.green[200],
      _dark: colors.green[200],
    },
    callGuideTagAssignedBg: {
      default: chakraPink[50],
      _dark: chakraPink[50],
    },
    callGuideTagAssignedText: {
      default: chakraPink[700],
      _dark: chakraPink[700],
    },
    callGuideTagRecentBg: {
      default: colors.gray[100],
      _dark: colors.gray[100],
    },
    callGuideTagRecentText: {
      default: colors.gray[800],
      _dark: colors.gray[800],
    },
    callGuideTagPositionText: {
      default: colors.gray[400],
      _dark: colors.gray[400],
    },
    callGuideV2TagPositionBg: {
      default: colors.green[50],
      _dark: colors.green[50],
    },
    callGuideV2TagPositionText: {
      default: colors.green[600],
      _dark: colors.green[600],
    },
    callGuideV2TagAssignedBg: {
      default: colors.blue[50],
      _dark: colors.blue[50],
    },
    callGuideV2TagAssignedText: {
      default: colors.blue[600],
      _dark: colors.blue[600],
    },
    callGuideV2TagRecentBg: {
      default: "#FAF5FF",
      _dark: "#FAF5FF",
    },
    callGuideV2TagRecentText: {
      default: colors.purple[600],
      _dark: colors.purple[600],
    },
    selectOptionBg: {
      default: colors.white,
      _dark: colors.white,
    },
    selectOptionFocusBg: {
      default: "#EDF8FE",
      _dark: "#EDF8FE",
    },
    selectOptionText: {
      default: colors.primary,
      _dark: colors.primary,
    },
    selectAccent: {
      default: colors.blue[500],
      _dark: colors.blue[500],
    },
    selectMultiValueBg: {
      default: colors.blue[50],
      _dark: colors.blue[50],
    },
    bannerBlueText: {
      default: colors.blue[700],
      _dark: colors.blue[700],
    },
    bannerGreenText: {
      default: colors.green[700],
      _dark: colors.green[700],
    },
    statusSuccessBg: {
      default: colors.green[50],
      _dark: colors.green[900],
    },
    statusErrorBg: {
      default: colors.red[50],
      _dark: colors.red[900],
    },
    statusWarningBg: {
      default: colors.orange[50],
      _dark: colors.orange[900],
    },
    statusInfoBg: {
      default: colors.blue[50],
      _dark: colors.blue[900],
    },
    interviewFooterBg: {
      default: "#F0F5FD",
      _dark: "#F0F5FD",
    },
  },
} as const;

export default semanticTokens;
